import React from "react"

import PricePage from "../../components/CatalogCeramic/PricePage"
import { ceramicCars } from "../../components/CatalogCeramic/data"

const KatalizatorPage = () => <PricePage data={ceramicCars[0]} />

export default KatalizatorPage
